import { FieldCorrection } from '@/features/ticket/components/TicketDetailsDialog/CorrectionTimeline';
import { StateCreator } from 'zustand';
// import type { FieldCorrection } from '@/components/CorrectionTimeline';

export interface CorrectionOverlaySlice {
  // All corrections for the currently open ticket
  overlayCorrections: FieldCorrection[];
  // Which correction is highlighted (hovered/focused in timeline)
  highlightedCorrectionId: string | null;
  // Whether overlay is visible (hidden during edit mode)
  overlayVisible: boolean;
  editingCorrectionId: string | null;

  setOverlayCorrections: (corrections: FieldCorrection[]) => void;
  setHighlightedCorrection: (id: string | null) => void;
  setOverlayVisible: (visible: boolean) => void;
  clearOverlay: () => void;
  requestEditCorrection: (id: string) => void;
  clearEditRequest: () => void;
}

export const createCorrectionOverlaySlice: StateCreator<
  CorrectionOverlaySlice
> = (set) => ({
  overlayCorrections: [],
  highlightedCorrectionId: null,
  overlayVisible: true,
  editingCorrectionId: null,

  setOverlayCorrections: (corrections) =>
    set({ overlayCorrections: corrections, overlayVisible: true }),
  setHighlightedCorrection: (id) => set({ highlightedCorrectionId: id }),
  setOverlayVisible: (visible) => set({ overlayVisible: visible }),
  clearOverlay: () =>
    set({
      overlayCorrections: [],
      highlightedCorrectionId: null,
      overlayVisible: true,
    }),
  requestEditCorrection: (id) =>
    set({ editingCorrectionId: id, overlayVisible: false }),
  clearEditRequest: () =>
    set({ editingCorrectionId: null, overlayVisible: true }),
});
